const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'];

export const checkIsImageByFileName = (fileName: string): boolean => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  return !!ext && IMAGE_EXTENSIONS.includes(ext);
};
